
<template>
  <div>
    <div class="absolute-black" v-if="is_show_modal && is_fon"></div>
    <div :id="id" class="modal modal-drawer has-shown"  :style="{'display': display , 'backdrop' : display, 'keyboard' : keyboard}">
      <div class="modal-dialog modal-drawer-right" :class="[size != undefined ? size : 'modal-lg']" role="document">
        <div class="modal-content shadow-lg">
          <div v-show="!isMobile" @click="closeModal()" class="close-drawer-modal bg-danger pointer">
            Close
          </div>
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <div v-show="isMobile" @click="closeModal()" class="close-drawer-modal-moblile bg-danger pointer">X</div>
          </div>
          <div class="modal-body overflow-y-auto">
            <div class="container ">
            <slot></slot>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rightModalWidget",
  props: [
    'id', 'title', 'size'
  ],
  data: function(){
    return {
      isMobile: window.innerWidth < 767,
      is_show_modal: false,
      is_fon: true,
      display: 'none',
			backdrop: true,
			keyboard: true
    }
  },
  methods: {
    openModal(){
      var app = this;
      app.is_show_modal = true;
			this.display='block';
			app.is_fon = true;
    },
    closeModal(){
      var app = this;
      app.is_show_modal = false;
			this.display='none';
			app.$emit('close-modal');
    },
  },
  mounted: function(){
    var app = this;
  }
}
</script>
<style>
.absolute-black{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,0.6);
	z-index: 1200;
}
.modal-drawer{
	margin-top: 0.5%;
	height: 98.5%;
	margin-bottom: 1%;
	animation-duration: 0.55s;
	animation-fill-mode: both;
	animation-name: fadeInDownModal;
	z-index: 1202;
}

@keyframes fadeInDownModal {
	0% {
		opacity: 0;
		transform: translateX(200%);
	}
	100% {
		opacity: 1;
		transform: none;
	}
}
</style>
